export function formatTwoDigits(input: number | string) {
  const value = Number(input);

  return `${value}`.padStart(2, '0');
}
